import {TAppInitialController} from 'core/redux/types';
import {getMenuList} from 'modules/menu/thunks';

export const menuController: TAppInitialController<void> = async (store, _) => {
    await store.dispatch(getMenuList);
};
